import { Component, EventEmitter, Input, Output, type OnChanges, type OnInit } from '@angular/core';
import { ExternalLinkService } from '@big-direkt/utils/shared';

@Component({
    selector: 'big-ui-link',
    templateUrl: './link.component.html',
    standalone: false,
})
export class LinkComponent implements OnInit, OnChanges {
    @Input() public href = '';
    @Input() public linkClass = '';
    @Input() public linkId?: string;
    @Input() public target?: '_blank' | '_parent' | '_self' | '_top' | '';
    @Input() public download?: string;
    @Output() public readonly linkClicked = new EventEmitter<'external_link' | 'internal_link'>();

    public isExternal!: boolean;

    public constructor(private readonly externalLinkService: ExternalLinkService) {}

    public ngOnChanges(): void {
        this.isExternal = this.externalLinkService.isExternal(this.href);
    }
    public ngOnInit(): void {
        this.isExternal = this.externalLinkService.isExternal(this.href);

        if (!this.target) {
            this.target = this.externalLinkService.getTarget(this.isExternal);
        }
    }

    public onLinkClicked(): void {
        this.linkClicked.emit(this.isExternal ? 'external_link' : 'internal_link');
    }
}
